"use client"

import React from "react"
import { RelatedArticles } from "@/types"
import Heading from "../../Atoms/Heading"
import ArticleCard from "../../Organisms/Cards/ArticleCard"
import { ShowAllPressroomArticles } from "../../Organisms/Cards/ShowAllPressroomArticles"
import { getLangCode } from "@/app/(site)/_utils/misc"
import { t } from "@/translations"

type Props = {
    data: RelatedArticles
    isAboveTheFold?: boolean
    params: { locale: string }
}

const ArticleList: React.FC<Props> = ({ data, isAboveTheFold, params }) => {
    const headingType = isAboveTheFold ? "h1" : "componentHeading"
    const language = getLangCode(params.locale) as string

    return (
        <div className="mx-16 md:mx-24">
            {data?.heading && (
                <Heading type={headingType} className="mb-24">
                    {data?.heading}
                </Heading>
            )}

            <div className="relative flex snap-x snap-mandatory gap-4 overflow-hidden overflow-x-auto scroll-smooth lg:grid lg:grid-cols-4 lg:gap-16">
                {Array.isArray(data?.relatedArticles) &&
                    data.relatedArticles.length > 0 &&
                    data.relatedArticles.map(
                        (article: RelatedArticles, index: number) => (
                            <React.Fragment key={index}>
                                <div className="w-[250px] flex-shrink-0 snap-start lg:w-auto">
                                    <ArticleCard
                                        index={index}
                                        article={article}
                                        locale={params.locale}
                                        key={index}
                                    />
                                </div>

                                {index === 1 && (
                                    <div className="w-[250px] flex-shrink-0 snap-start lg:w-auto">
                                        <ShowAllPressroomArticles
                                            title={t(language, "Show more")}
                                            url={`/${article?.preSlug}`}
                                        />
                                    </div>
                                )}
                            </React.Fragment>
                        )
                    )}
            </div>
        </div>
    )
}

export default ArticleList
